import IconBox from '../../components/common/icon-box'
import AccountLayout from '../../components/layout/account-layout'
import MetalAccountBalance from '../../components/common/metal-account-balance'
import { useTranslation } from '../../useTranslation'
import ControlledRadioButtons from '../../components/form/controlled-radio-buttons'
import { useMemo } from 'react'
import { UpdateMetalAccountOrderPreferenceDTO, UserDTOMetalAccountOrderPreferenceEnum } from '@ringo/shared'
import { useForm } from 'react-hook-form'
import { useUser } from '../../common/hooks/auth/useUser'
import { useMutation } from '@tanstack/react-query'
import { useUserApi } from '../../common/api-context'
import Button from '../../components/common/button'
import { toast } from 'react-toastify'

const MetalAccount = () => {
    const { t } = useTranslation()
    const { user, refreshUserData } = useUser()
    const userApi = useUserApi()

    const metalAccountOrderPreferenceOptions = useMemo(() => {
        return [
            { id: UserDTOMetalAccountOrderPreferenceEnum.AlwaysAsk, label: t('myAccount.metalAccount.orderPreference.alwaysAsk') },
            { id: UserDTOMetalAccountOrderPreferenceEnum.DefaultWithMetalAccount, label: t('myAccount.metalAccount.orderPreference.defaultWithMetalAccount') },
            {
                id: UserDTOMetalAccountOrderPreferenceEnum.DefaultWithoutMetalAccount,
                label: t('myAccount.metalAccount.orderPreference.defaultWithoutMetalAccount'),
            },
        ]
    }, [t])

    const metalAccountOrderPrererenceMutation = useMutation({
        mutationFn: async (data: UpdateMetalAccountOrderPreferenceDTO) => {
            var res = await userApi.updateMetalAccountOrderPreference(data)
            await refreshUserData()
            toast.success(t('myAccount.metalAccount.orderPreference.updatedSuccessfully'))
            return res
        },
    })

    const { control, handleSubmit } = useForm<UpdateMetalAccountOrderPreferenceDTO>({
        defaultValues: { metalAccountOrderPreference: user?.metalAccountOrderPreference },
    })

    return (
        <AccountLayout>
            <div className="">
                <IconBox icon={'ring'}>
                    <div className="pt-12 pb-6 px-2 max-tablet:pt-10 max-tablet:pb-8">
                        <p className="font-bold text-xl text-left leading-none mb-10 max-tablet:text-base max-tablet:mb-5">
                            {t('myAccount.navLink.metalAccount')}
                        </p>
                        <div className="flex flex-col gap-4">
                            <MetalAccountBalance />

                            <div className="text-left border-t-2 pt-2 text-base">
                                <div className="font-bold">{t('myAccount.metalAccount.orderPreference')}</div>
                                <div>{t('myAccount.metalAccount.orderPreference.desc')}</div>
                                <ControlledRadioButtons
                                    control={control}
                                    name="metalAccountOrderPreference"
                                    options={metalAccountOrderPreferenceOptions}
                                ></ControlledRadioButtons>

                                <Button
                                    onClick={handleSubmit((data) => metalAccountOrderPrererenceMutation.mutateAsync(data), console.log)}
                                    text={t('save')}
                                    className="mt-3"
                                    type={'squareBlue'}
                                ></Button>
                            </div>
                        </div>
                    </div>
                </IconBox>
            </div>
        </AccountLayout>
    )
}

export default MetalAccount
